import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { togglePopup } from 'actions/appAction';

import { PopupBoxClose, PopupButtons, PopupContent, PopupHeader } from './styles';
import { DiskButton } from '../DiskButton/DiskButton';
import { Text } from '../Text/Text';

const SimplePopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        return () => {
            if (props.onPopupClose) {
                props.onPopupClose();
            }
        };
    }, []);

    return (
        <div data-testid={props.dataTestId}>
            {!props.withoutCloseButton && (
                <PopupBoxClose>
                    <DiskButton
                        onClick={() => {
                            if (props.handleClose) {
                                props.handleClose();
                            } else if (popupRef?.current) {
                                popupRef.current?.close();
                            } else {
                                props.togglePopup(false);
                            }
                        }}
                        iconName="cross"
                        iconColor="mediumGray"
                        size="small"
                        type="button"
                        variant="tertiary"
                        raised={false}
                    />
                </PopupBoxClose>
            )}
            <PopupContent>
                {props.text && (
                    <PopupHeader>
                        <Text variant="div" textAlign={props.textAlign}>
                            {props.text}
                        </Text>
                    </PopupHeader>
                )}
                <PopupButtons withoutBorder={props.withoutBorder}>{props.children}</PopupButtons>
            </PopupContent>
        </div>
    );
};
SimplePopup.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    withoutCloseButton: PropTypes.bool,
    withoutBorder: PropTypes.bool,
    textAlign: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    handleClose: PropTypes.func,
    dataTestId: PropTypes.string,
};
export default connect(null, { togglePopup })(SimplePopup);
